import { render, staticRenderFns } from "./FormationsItem.vue?vue&type=template&id=9e1a42b4&"
import script from "./FormationsItem.vue?vue&type=script&lang=js&"
export * from "./FormationsItem.vue?vue&type=script&lang=js&"
import style0 from "./FormationsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports